import useI18n from '@/hooks/useI18n';
import React from 'react';

interface StepperProps {
  currentStep: number;
  totalSteps: number;
  onStepClick: (step: number) => void;
}

const Stepper: React.FC<StepperProps> = ({
  currentStep,
  totalSteps,
  onStepClick,
}) => {
  const { t } = useI18n();

  return (
    <div className="flex flex-col items-start">
      <div className="text-2xl text-[#B3B3B299] mb-2 font-normal">
        <span className="text-[#06B217]"> {currentStep}</span> {t(`common.of`)}{' '}
        {totalSteps - 1} {t(`common.steps`)} {t(`common.completed`)}
      </div>
      <div className="flex items-center space-x-2">
        {Array.from({ length: totalSteps - 1 }, (_, index) => {
          const step = index + 1;
          const isCompleted = step < currentStep;
          const isCurrent = step === currentStep;
          const isClickable = step <= currentStep;

          return (
            <React.Fragment key={step}>
              <div
                className={`w-[48px] h-[48px] flex items-center justify-center rounded-full border-2 ${
                  isCompleted
                    ? '!w-[38px] !h-[38px] bg-[#06B217] border-[#06B217]'
                    : isCurrent
                      ? 'border-dashed border-[#B3B3B299]'
                      : 'border-[#B3B3B299]'
                } ${isClickable ? 'cursor-pointer hover:opacity-75' : 'cursor-not-allowed'}`}
                onClick={() => isClickable && onStepClick(step)}
              >
                {isCompleted ? (
                  <img src="/assets/whiteCheck.svg" className="h-5 w-5" />
                ) : isCurrent ? (
                  <div className="w-[24px] h-[24px] bg-[#06B217] rounded-full"></div>
                ) : (
                  <span className="text-[#172B4DCC] font-normal text-2xl">
                    {step}
                  </span>
                )}
              </div>
              {step < totalSteps - 1 && (
                <div className="flex gap-[8px]">
                  <div className="w-[8px] h-[8px] rounded-full bg-[#B3B3B299]"></div>
                  <div className="w-[8px] h-[8px] rounded-full bg-[#B3B3B299]"></div>
                  <div className="w-[8px] h-[8px] rounded-full bg-[#B3B3B299]"></div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
